import React from "react";
import DataGridContrats from "./datagrid/DataGridContrats";

const Contrats = () => {
  return (
    <div>
      <div>
        <h1 className="h2 text-success">Listes des contrats</h1>
      </div>
      <DataGridContrats />
    </div>
  );
};

export default Contrats;
